import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

const config = {
    mode: 'history',
    linkExactActiveClass: 'active',
    linkActiveClass: 'active',
    routes: [
        {
            path: '/:locale',
            component: require('../App.vue'),
        },
        {
            path: '*',
            redirect: '/fr',
        },           
    ]
} as Router.RouterOptions;

export default new Router(config);


// WEBPACK FOOTER //
// ./src/router/index.ts